import type { FC } from 'react'
import styles from './part-line-text.module.css'

export interface PartLineTextProps {
  /** The merged header line, segments joined by " · " (see partHeaderLine) */
  line: string
}

/**
 * Renders the part header line so it breaks only between segments, and before the "·", never after it:
 * "Key E♭ · capo 3, C shapes" / "· transposed +5", not a separator stranded at a line's end.
 */
export const PartLineText: FC<PartLineTextProps> = ({ line }) => (
  <span data-part-line="">
    {line.split(' · ').map((segment, idx) => (
      <span key={idx}>
        {idx > 0 ? ' ' : null}
        <span className={styles.segment}>{idx > 0 ? `· ${segment}` : segment}</span>
      </span>
    ))}
  </span>
)
